import { useEffect, useRef, useState } from 'react';
import './Testimonials.css';

const testimonials = [
  {
    text: 'The trading system I learnt here is awesome, Sir. I am thankful to you for the wonderful hand holding; your teaching is making me a money-making machine. A big thank you!',
    author: 'Vivek Kulkarni',
    role: 'Program Participant',
  },
  {
    text: 'The courses offered are very insightful and practical. I highly recommend Thakur Capital for anyone looking to succeed in the stock market.',
    author: 'Onkar Kumbhar',
    role: 'Program Participant',
  },
  {
    text: 'Excellent support and resources. The guidance provided has been instrumental in my trading journey.',
    author: 'Nitin',
    role: 'Program Participant',
  },
];

const Testimonials = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const touchStartX = useRef(null);

  const showNext = () => {
    setActiveIndex((current) => (current + 1) % testimonials.length);
  };

  const showPrevious = () => {
    setActiveIndex((current) => (current - 1 + testimonials.length) % testimonials.length);
  };

  useEffect(() => {
    if (testimonials.length < 2) return undefined;

    const carousel = setInterval(() => {
      setActiveIndex((current) => (current + 1) % testimonials.length);
    }, 5500);

    return () => clearInterval(carousel);
  }, []);

  const handleTouchEnd = (event) => {
    if (touchStartX.current === null) return;

    const distance = event.changedTouches[0].clientX - touchStartX.current;
    touchStartX.current = null;

    if (Math.abs(distance) < 45) return;
    if (distance < 0) showNext();
    else showPrevious();
  };

  return (
    <section className="testimonials-section" aria-labelledby="testimonials-title">
      <div className="container testimonials-container">
        <div className="testimonials-heading">
          <span className="testimonials-eyebrow">Student stories</span>
          <h2 id="testimonials-title">Trusted by learners who take action</h2>
          <p>Real experiences from the Thakur Capital learning community.</p>
        </div>

        <div
          className="testimonial-carousel"
          aria-roledescription="carousel"
          aria-label="Student testimonials"
          onTouchStart={(event) => { touchStartX.current = event.touches[0].clientX; }}
          onTouchEnd={handleTouchEnd}
        >
          <div
            className="testimonial-track"
            style={{ transform: `translateX(-${activeIndex * 100}%)` }}
          >
            {testimonials.map((testimonial, index) => (
              <article className="testimonial-slide" key={testimonial.author} aria-hidden={index !== activeIndex}>
                <div className="testimonial-card">
                  <span className="testimonial-quote" aria-hidden="true">“</span>
                  <div className="testimonial-stars" aria-label="5 out of 5 stars">★★★★★</div>
                  <blockquote>{testimonial.text}</blockquote>
                  <footer>
                    <span className="testimonial-avatar" aria-hidden="true">{testimonial.author.charAt(0)}</span>
                    <div>
                      <cite>{testimonial.author}</cite>
                      <span>{testimonial.role}</span>
                    </div>
                  </footer>
                </div>
              </article>
            ))}
          </div>

          <div className="testimonial-progress" aria-hidden="true">
            {testimonials.map((testimonial, index) => (
              <span className={index === activeIndex ? 'is-active' : ''} key={testimonial.author} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export { Testimonials };
